import axios from "axios";
const commonMixins = {
    methods: {
      async update_app_record(name){
        if(this.$store.state.initiate_pending){
          //if an initiate session call is already pending try to update this value again in 500ms
          setTimeout(()=>{this.update_app_record(name)}, 500);
          return;
        }else if(!this.$store.state.is_initiated){      
          this.initiate_app_record();
          setTimeout(()=>{this.update_app_record(name)}, 500);
        }
  
          
        this.$store.state.pending_update = true;
        setTimeout(async()=>{
            if(this.$refs[name] && !this.$refs[name].valid) return;          
            let value = typeof this[name] =='object' && this[name] != null ? JSON.stringify(this[name]) : this[name];
            if(typeof value == 'string') value = value.trim();
            const update = await axios.post(`${this.$baseURL}/common/application/`, 
                JSON.stringify({doCmd:'update_app_record', app_id: window.sessionStorage.getItem('appID'), field: name, value: value}), {
                headers : {'Content-Type': 'application/json'}
            });
            this.$store.state.pending_update = false;
            const {data:{error, errortext}} = update;
            if(error > 0){                
                this.showError = true;
                this.errorObj = {error:error, errortext:errortext};
                this.errorIsFatal=false;
                return;
            }
        }, 200); //kind of an ugly way to do this but make sure that the value is set before actually updating it
      },
      async initiate_app_record(){
        if(this.$store.state.initiate_pending || this.$store.state.is_initiated) return; //we're already doing this. no need to do it again
        this.$store.commit('attemptedToInitiate');
        this.$store.state.initiate_pending  = true;
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('validate_captcha');
        const iar = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify({doCmd:'initiate_app_record', app_id: window.sessionStorage.getItem('appID'), recaptcha: token}), {
          headers : {'Content-Type': 'application/json'}
        });
        const {status, data: {error, errorref, result: {db_app_id}} } = iar;
        
        if(status >= 500 ){              
          if(this.$store.state.initiate_attempts > 5){
            this.showError = true;
            const log = await this.log_activity('Unable to reach server for initiate app request', iar);
            this.errorObj = {error: 1, errorref:log.data.errorref, errortext: 'An unexpected error occured initiating your app record. Please reload the page to continue.'};
            this.errorIsFatal = true;            
            return;
          }else{
            this.log_activity('Initiate app record failed, another attempt will be made.', iar);
            this.initiate_app_record();
          }
        }
        if(!db_app_id){
          if(this.$store.state.initiate_attempts > 5){
            this.showError = true;
            this.errorObj = {error: error, errortext: 'An unexpected error occured initiating your app record. Please reload the page to continue.', errorref: errorref};
            this.errorIsFatal = true;
            return;
          }else{
            this.log_activity('Initiate app record failed, another attempt will be made.', iar);
            this.initiate_app_record();
          }
        }
        
        this.$store.state.initiate_pending = false;
        this.$store.state.is_initiated = true;        
      },
      log_activity(description, detail={}){
        return axios.post(`${this.$baseURL}/common/application/`, JSON.stringify({doCmd:'log_activity_from_client', app_id: window.sessionStorage.getItem('appID'),activityDesc: description, detail:detail}), {
            headers : {'Content-Type': 'application/json'}
        }); 
      },
      
    }
  }

  export default commonMixins